import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";
import { FaFilePdf } from "react-icons/fa";

const ModuleSubtopicMemoryTraffic = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Memory Traffic Calculations (Very Important)"
    videos={[]} // No videos available
    takeaways={[
      { text: "Learn theory part related to this (mainly how instruction is represented in different formats)." },
      { text: "Learn how to represent a single expression in different formats." },
      { text: "Memory traffic calculations are very important." },
      { text: "Another possible question is identifying the type of instruction from given instructions." },
      {
        text: (
          <span>
            Refer to the PDF:&nbsp;
            <a
              href="https://drive.google.com/file/d/1UsedqU7LQmUZvfrmi_L-dxZu6LuGgALo/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                color: "#0f4c75",
                textDecoration: "none",
              }}
            >
              <FaFilePdf style={{ marginRight: "6px" }} />
              View PDF
            </a>
          </span>
        ),
      },
    ]}
    questions={[
      "What is memory traffic and how is it calculated?",
      "How are instructions represented in different formats?",
      "Identify the type of instruction from the given set.",
    ]}
    exampleVideos={[]} // No example videos
  />
);
}

export { ModuleSubtopicMemoryTraffic };
